import { render, staticRenderFns } from "./SafetyObservationCategoryNew.vue?vue&type=template&id=cf2ae162&"
import script from "./SafetyObservationCategoryNew.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports